import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { Links } from "../../helpers/Links";
import { ChiTietBienBanBanGiaoModel } from "../../models/taisan/BienBanBanGiao";
import LoadingDetailPage from "../../modules/loading/LoadingDetailPage";
import { layChiTietBienBan } from "../../services/bienBanBanGiao";
import LuuBienBanBanGiaoBox from "./LuuBienBanBanGiaoBox";

const ChiTietBienBanBanGiao = () => {
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [bienBan, setBienBan] = useState<ChiTietBienBanBanGiaoModel | null>(null);

    const loadChiTiet = async () => {
        if (!id) {
            setBienBan(null);
            return;
        }

        try {
            setIsLoading(true);
            const result = await layChiTietBienBan(parseInt(id));
            setBienBan(result);
        } catch (error: any) {
            toast.error('Lỗi khi tải chi tiết biên bản: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = () => {
        navigate(Links.BienBanBanGiao.DanhSach);
    };

    useEffect(() => {
        loadChiTiet();
    }, [id]);

    if (isLoading) {
        return <LoadingDetailPage title={id ? "Sửa biên bản bàn giao" : "Thêm biên bản bàn giao"} />;
    }

    return (
        <section>
            <ContentHeader title={id ? "Sửa biên bản bàn giao" : "Thêm biên bản bàn giao"} />
            <div className="container-fluid">
                <div className="card">
                    <div className="card-body">
                        <LuuBienBanBanGiaoBox
                            modelProps={bienBan}
                            onSubmit={handleSubmit}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ChiTietBienBanBanGiao;
